define.alias("shared/components/shared/ai-credits/info", "calendar/components/shared/ai-credits/info");